/**
 * Publication Sync Hooks
 * Provides React Query hooks for publication sync status and retry operations.
 * @packageDocumentation
 */

import { trpc } from '@/api/tRpc';
import { STALE_SHORT } from '@/lib/query-options';

/**
 * Fetches the publication sync status for the given retailer/environment.
 *
 * @param { string | undefined } retailerCode The retailer code.
 * @param { string | undefined } environment The environment name.
 * @returns The query result with sync status data.
 */
export const usePublicationSyncStatus = (retailerCode: string | undefined, environment: string | undefined) =>
  trpc.publicationSync.getSyncStatus.useQuery(undefined, {
    staleTime: STALE_SHORT,
    enabled: !!retailerCode && !!environment,
  });

/**
 * Mutation hook for retrying publication sync.
 *
 * @returns The mutation result with retry functionality.
 */
export const useRetryPublicationSync = () => {
  const utils = trpc.useUtils();

  return trpc.publicationSync.retrySync.useMutation({
    onSuccess: () => {
      utils.publicationSync.getSyncStatus.invalidate();
    },
  });
};
